import onSearchTextChanged from '../actions/onSearchTextChanged';
import onSearchTextChangedInternal from '../actions/onSearchTextChangedInternal';
import { orchestrator } from 'satcheljs';

orchestrator(onSearchTextChanged, actionMessage => {
    const { searchText, scenarioId, showSuggestionsUi } = actionMessage;
    onSearchTextChangedInternal(searchText, scenarioId, showSuggestionsUi);
});
